export default __webpack_public_path__ + "static/media/forgot-password-bg.5351d689.png";